export default "__VITE_ASSET__DZhJYJGK__"